export default __webpack_public_path__ + "static/media/RisingSunIcon.e20e3e89.svg";